import { Component, computed, input } from '@angular/core';
import { PrivilegeNode } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-privilege-icon',
  templateUrl: './privilege-icon.component.html',
  styleUrls: ['./privilege-icon.component.scss']
})
export class PrivilegeIconComponent {
  readonly privilege = input.required<PrivilegeNode.IconEnum>();

  readonly icon = computed(() => {
    switch (this.privilege()) {
      case PrivilegeNode.IconEnum.Statistics:
        return 'chart-bar';
      case PrivilegeNode.IconEnum.UserManagement:
        return 'user';
      case PrivilegeNode.IconEnum.B1300:
        return 'clipboard-check';
      case PrivilegeNode.IconEnum.Cockpit:
        return 'diagram-project';
      case PrivilegeNode.IconEnum.Buildings:
        return 'house';
      case PrivilegeNode.IconEnum.Contractors:
        return 'hammer';
      case PrivilegeNode.IconEnum.System:
        return 'gear';
      case PrivilegeNode.IconEnum.Monitoring:
        return 'bolt';
      case PrivilegeNode.IconEnum.Protocols:
        return 'file-contract';
    }
    return undefined;
  });
}
